import { Injectable, OnInit } from '@angular/core';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { UserDocument } from '../app.component';
import { Router } from '@angular/router';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';

import { v4 as uuidv4 } from 'uuid';
import { Auth, signInAnonymously, UserCredential } from '@angular/fire/auth';
import { Firestore, collection, deleteDoc, doc, getDoc, getDocs, query, setDoc, where } from '@angular/fire/firestore';
import { signInWithEmailAndPassword, deleteUser } from '@angular/fire/auth';
import { getAuth } from 'firebase/auth'; // 🔹 Ajouté pour éviter les conflits de versions
import bcrypt from 'bcryptjs/umd/types';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  firestore = new FirebaseTSFirestore();
  auth = new FirebaseTSAuth();
  private authInstance = getAuth(); // 🔹 Récupération explicite de l'instance Firebase Auth

  confirmationResult: firebase.auth.ConfirmationResult;

  
  constructor(private router: Router, public afAuth: AngularFireAuth , private angularAuth: Auth, private firestore2: Firestore ) {}
  

   // Méthode pour vérifier si l'utilisateur est authentifié
   isAuthenticated(): boolean {
    const currentUser = this.auth.getAuth().currentUser;

    // Vérifiez d'abord si currentUser n'est pas null
    if (currentUser && currentUser.uid) {
      return true; // Utilisateur authentifié
    } else {
      return false; // Utilisateur non authentifié
    }
  }

  isAuthenticatedAnonymous(): boolean {
    const currentUser = this.auth.getAuth().currentUser;
  
    if (currentUser) {
      // Vérifier si l'utilisateur est anonyme
      return currentUser.isAnonymous; // Retourne true seulement si l'utilisateur n'est PAS anonyme
    }
    return false;
  }

  



  async signInWithEmailAndPassword(uid: string, password: string, phoneNumber: string): Promise<void> {

          
    return new Promise<void>(async (resolve, reject) => {


      const authInstance = this.auth.getAuth();
      const currentUser = authInstance.currentUser;
      
  
      let anonymousUID: string | null = null;
      
  
      // 📌 Vérifier si l'utilisateur actuel est anonyme
      if (currentUser?.isAnonymous) {
        anonymousUID = currentUser.uid; // Sauvegarde de l'UID anonyme
        console.log("Utilisateur anonyme détecté avec UID:", anonymousUID);
      }

      
  
      const email = phoneNumber+ "@lenali.ml"; // Générer l'email fictif
  
      try {

         // Rechercher l'utilisateur par son numéro de téléphone dans Firestore
         const usersRef = collection(this.firestore2, 'Users');
         const q = query(usersRef, where('zangiNumber', '==', phoneNumber));
         const querySnapshot = await getDocs(q);
   
         if (querySnapshot.empty) {
           console.log('Numéro de téléphone introuvable.');
           return;
         }
   
         const userData = querySnapshot.docs[0].data();
         const anonymousUID = querySnapshot.docs[0].id;
         
         const storedPasswordHash = userData.password;

        // ⚡ Vérifier si l'email existe déjà
        await this.auth.signInWith({
          email,
          password,
          onComplete: async (user) => {
            console.log("Connexion réussie avec l'email:", email);
  
            // 🔥 Supprimer l'ancien utilisateur anonyme après connexion réussie
            if (currentUser?.isAnonymous) {
              try {
                await authInstance.currentUser?.delete();
                console.log("Utilisateur anonyme supprimé avec succès.");
              } catch (error) {
                console.error("Erreur lors de la suppression de l’utilisateur anonyme:", error);
              }
            }
  
            resolve();
          },
          onFail: async (err) => {
            console.log("L'utilisateur n'existe pas, création du compte...");
            try {
              // 🎉 Création du compte avec email et mot de passe
              await this.auth.createAccountWith({
                email,
                password,
                onComplete: async (userCredential) => {
                  console.log("Compte créé avec succès:", userCredential.user.uid);
                  await this.transferAnonymousData(anonymousUID, userCredential.user.uid);
                  // 🔄 Associer les anciennes données de l'utilisateur anonyme
                 /* if (anonymousUID) {
                    await this.transferAnonymousData(anonymousUID, userCredential.user.uid);
                    alert(anonymousUID+ " " +userCredential.user.uid);
                  } */
  
                  resolve();
                },
                onFail: (createError) => {
                  console.error("Erreur lors de la création du compte:", createError);
                  reject(createError);
                },
              });
            } catch (createError) {
              reject(createError);
            }
          },
        });
      } catch (error) {
        reject(error);
      }
    });
  }


  async transferAnonymousData(oldUID: string, newUID: string): Promise<void> {
    const userRef = doc(this.firestore2, "Users", oldUID);
    const newUserRef = doc(this.firestore2, "Users", newUID);
    console.log(oldUID, "transfert à", newUID);
    
    try {
      // 🔍 Récupérer les anciennes données de Firestore
      
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        const userData = userDoc.data();
  
        // 🔄 Copier les données dans le nouveau compte
        await setDoc(newUserRef, { ...userData, uid: newUID });
  
        console.log("Données transférées de", oldUID, "vers", newUID);
      }
  
      // ❌ Supprimer l'ancien document utilisateur anonyme
      await deleteDoc(userRef);
      console.log("Ancien compte anonyme supprimé.");
    } catch (error) {
      console.error("Erreur lors du transfert des données:", error);
    }
  }
  
  


  

 
  
  

  

  // Méthode pour connecter l'utilisateur
  login(username: string, password: string): boolean {
    // Exemple simple avec des données statiques
    if (username === 'admin' && password === 'admin123') {
      // Stocker un token dans le localStorage
      localStorage.setItem('authToken', 'dummy-token');
      return true;
    }
    return false;
  }

  // Méthode pour déconnecter l'utilisateur
  logout(): void {
    // Supprimer le token d'authentification du localStorage
    localStorage.removeItem('authToken');
    this.auth.signOut();
    // Rediriger vers la page d'accueil ou de connexion
    this.router.navigate(['/']);
  }


   // Initialiser reCAPTCHA
   setupReCAPTCHA(containerId: string) {
    return new firebase.auth.RecaptchaVerifier(containerId, {
      size: 'invisible',
      callback: (response) => {
        console.log('reCAPTCHA solved:', response);
      }
    });
  }

  // Connexion par numéro de téléphone
  signInWithPhoneNumber(phoneNumber: string, appVerifier: firebase.auth.RecaptchaVerifier) {
    return this.afAuth.signInWithPhoneNumber(phoneNumber, appVerifier);
  }

  // Vérifier le code envoyé par SMS
  verifyCode(verificationCode: string, confirmationResult: firebase.auth.ConfirmationResult) {
    return confirmationResult.confirm(verificationCode);
  }


  //Authentification anonyme
  loginAnonymously(firstName: string, lastName: string, zangiNumber: string,){
    return signInAnonymously(this.angularAuth)
      .then((userCredential: UserCredential) => {
        const user = userCredential.user;
        if (user) {
          const userData = {
            uid: user.uid,
            zangiNumber: zangiNumber,
            firstName: firstName,
            lastName: lastName,
            password: '',  // Stockera un hash plus tard pour plus de sécurité
            createdAt: new Date().toISOString()
          };

          // Enregistrer les données utilisateur dans Firestore
          return setDoc(doc(this.firestore2, 'users', user.uid), userData)
            .then(() => {
              return zangiNumber; // Retourner userData après l'enregistrement
            })
            .catch(error => {
              console.error("Erreur lors de l'enregistrement des données utilisateur:", error);
              throw error;
            });
        } else {
          throw new Error("Utilisateur non trouvé après la connexion anonyme.");
        }
      })
      .catch(error => {
        console.error("Erreur connexion anonyme:", error);
        throw error;
      });
  }
  
  // Génère un numéro Zangi unique à 10 chiffres
  private generateZangiNumber(): string {
    return Math.floor(1000000000 + Math.random() * 9000000000).toString();
  }

  updatePassword(newPassword: string) {
    const user = this.auth.getAuth().currentUser;
    if (user) {
      user.updatePassword(newPassword)
        .then(() => console.log("Mot de passe mis à jour"))
        .catch(error => console.error("Erreur mise à jour du mot de passe:", error));
    }
  }
  
  
}
